const LANG_ID_HU = 3432150755;

// TODO: configure this after the user has logged in!
export default function getLangId(): number {
    return LANG_ID_HU;   
}